import { gql, useQuery } from '@apollo/client';
import IconCopy from '@apollo/icons/default/IconCopy.svg';
import { Button } from '@apollo/orbit';
import React from 'react';

import { Loading } from 'src/components/common/loading/Loading';
import { ErrorMessage } from 'src/components/errorMessage/ErrorMessage';
import {
  GetEndpointsQuery,
  GetEndpointsQueryVariables,
} from 'src/lib/graphqlTypes/types';

import { DomainStatusTable } from './components/endpointsTab/DomainStatusTable';

export const GET_ENDPOINTS_QUERY = gql`
  query GetEndpointsQuery($routerId: ID!) {
    cloud {
      router(id: $routerId) {
        id
        endpoints {
          default
          defaultEnabled
          custom
          primary
        }
      }
    }
  }
`;

/**
 * EndpointURLsPage Component
 *
 * This component renders the details of the router endpoint urls and associated information.
 *
 * @returns {JSX.Element} Rendered component.
 */
export const EndpointURLsPage = ({ routerId }: { routerId: string }) => {
  const { loading, error, data } = useQuery<
    GetEndpointsQuery,
    GetEndpointsQueryVariables
  >(GET_ENDPOINTS_QUERY, { variables: { routerId } });

  if (loading) {
    return (
      <div data-testid="loading-indicator">
        <Loading />
      </div>
    );
  }

  if (error) {
    return <ErrorMessage>{error.message}</ErrorMessage>;
  }

  return (
    <>
      <div className="mx-8 mb-6 mt-8 flex items-stretch">
        <h1 className="text-heading-2xl">Router Endpoint URLs</h1>
      </div>
      <div className="ml-8 flex flex-col gap-2 md:w-2/3 md:max-w-2/3">
        <div className="text-heading-xl">
          {data?.cloud?.router?.endpoints.primary} endpoint
        </div>
        <p className="text-body">
          Apollo automatically supplies an endpoint to each cloud supergraph or
          variant you create.
        </p>
        <div className="mb-6 flex w-full gap-2">
          <Button
            className="flex-1 justify-start"
            onClick={() => {}}
            type="button"
            variant="secondary"
            data-testid="primary-endpoint-copy-button"
            leftIcon={<IconCopy />}
          >
            {data?.cloud?.router?.endpoints.primary}
          </Button>
          <Button onClick={() => {}} type="button" variant="secondary">
            Edit Path
          </Button>
        </div>
        <DomainStatusTable />
      </div>
    </>
  );
};
